module.exports = __webpack_public_path__ + "img/Twitter_Verified_Badge.2106c319.svg";